import React, { createContext, useContext, useState } from 'react';
import { LayoutLoading } from 'src/layouts/LayoutLoading';

interface LayoutContextType {
  mainClassName: string;
  setMainClassName: (className: string) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mainClassName, setMainClassName] = useState<string>('');

  return (
    <LayoutContext.Provider value={{ mainClassName, setMainClassName }}>
      <>
        <LayoutLoading />
        {children}
      </>    
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within LayoutProvider');
  }
  return context;
}; 